import { getRandomString } from "./string";

enum TemporarySectionId {
    NewComponentPage = "newComponentPage",
    NewComponentSection = "newComponentSection",
    NewProjectSection = "newProjectSection",
    NewSectionFromSelection = "newSectionFromSelection",
    NewSectionFromSplit = "newSectionFromSplit",
    NewSectionFromCreateSubsection = "newSectionFromCreateSubsection"
}

function createTemporarySectionId(type: TemporarySectionId) {
    return `${type}${getRandomString()}`;
}

export {
    TemporarySectionId,
    createTemporarySectionId
};
